import { Modal } from "react-bootstrap";
import CloseIcon from "@mui/icons-material/Close";

type BaseModalProps = {
  show: boolean;
  setShow: (show: boolean) => void;
  title: string;
  body: React.ReactNode;
};

export const BaseModal = ({ show, setShow, title, body }: BaseModalProps) => {
  return (
    <Modal show={show} onHide={() => setShow(false)} centered>
      <Modal.Header className="border-b-1 justify-content-center mb-10">
        <Modal.Title className="text-center">{title}</Modal.Title>
        <CloseIcon
          className="bg-light"
          style={{
            position: "absolute",
            right: "0px",
            top: "0px",
            margin: "10px",
          }}
          onClick={() => setShow(false)}
        />
      </Modal.Header>
      <Modal.Body>{body}</Modal.Body>
    </Modal>
  );
};
